import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import SortableOrderCard from "./SortableOrderCard";
import { Order } from "@/types/ApiTypes";
import { useTranslation } from "react-i18next";


interface Props {
  title: string;
  orders: Order[];
  columnId: string;
}

export default function OrderColumn({ title, orders }: Props) {
  const { t  } = useTranslation();

  return (
    <div className="flex-1 mx-2 p-4 bg-gray-100 rounded-lg h-fit min-h-[300px] w-[300px] lg:w-[350px]   gap-2 flex flex-col">
      <h3 className="text-center font-semibold mb-4 text-lg">{title === "Finished Orders" ? t("chef.finished") : title === "Preparing Orders" ? t("chef.preparing"): t("chef.new")}</h3>
      <SortableContext items={orders.map((o) => o._id)} strategy={verticalListSortingStrategy}>
        {orders.map((order) => (
          <SortableOrderCard
            key={order._id}
            title={title}
            order={order}
          />
        ))}
      </SortableContext>
    </div>
  );
}
